<template>
  <swiper :class="$style.swiper" :options="swiperOption">
    <swiper-slide v-for="item of swiperList" :key="item.id" :class="$style['swiper-item']">
      <img :src="item.icon" />
      <div>
        <p>{{ item.name }}</p>
        <p>{{ item.role_name }}</p>
      </div>
      <button id="pickGift" v-if="item.can_get == 1">领取</button>
      <button id="viewCode" v-else style="background-color: #9d9d9d">查看</button>
    </swiper-slide>
  </swiper>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { Dialog } from 'vant';
import { signPickGift } from '@/api/activity';
import 'swiper/css/swiper.css'
let vm = ''

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    swiperList: {
      type: Array,
      default: () => []
    },
    totalNumber: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      pickGiftFlag: true, // 领取礼包防重复点击
    }
  },
  computed: {
    ...mapState("account", {
      userInfo: state => state.userInfo // 当前用户信息
    }),
    // 判断是否绑定游戏账号
    isBindAccount() {
      let flag = this.userInfo.game_user_id != 0 ? true : false
      return flag;
    },
    swiperOption() {
      return {
        preventClicks: false,
        direction: 'vertical',
        slidesPerView: 4,
        loop: this.swiperList.length > 4 ? true : false,
        autoplay: this.swiperList.length > 4 ? true : false,
        allowTouchMove: this.swiperList.length > 4 ? true : false, // 是否禁止触摸滑动
        on: {
          click(e) {
            const realIndex = this.realIndex
            if (e.target.id == 'pickGift') {
              vm.handleReceiveGift(vm.swiperList[realIndex])
            }
            if (e.target.id == 'viewCode') {
              vm.viewGiftCode(vm.swiperList[realIndex])
            }
          }
        }
      }
    }
  },
  created() {
    vm = this
  },
  methods: {
    ...mapMutations('giftCenter', {
      SHOW_GIFT_DIALOG: 'SHOW_GIFT_DIALOG',
      SET_GIFT_ITEM: 'SET_GIFT_ITEM'
    }),
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING',
      CHANGE_BIND_GAME: 'CHANGE_BIND_GAME'
    }),
    // 路由跳转
    handleLinkTo(name, query) {
      this.$router.push({ name, query })
    },
    // 点击礼包领取按钮
    async handleReceiveGift(item) {
      if (!this.isBindAccount) {
        this.CHANGE_BIND_GAME(true)
        return
      }
      // 累计签到次数为0的时候跳转到签到模块
      if (!this.totalNumber) {
        Dialog.confirm({
          title: '温馨提示',
          message: '您还没有签到，签到后才可以领取礼包哦！',
        }).then(() => {
          this.$emit('scrollToSign')
        }).catch(() => {
          this.$emit('scrollToSign')
        });
        return
      }
      if (this.pickGiftFlag) return;
      this.pickGiftFlag = true
      this.CHANGE_SHOW_LOADING(true)
      try {
        const r = await signPickGift({
          lucky_draw_game_config_id: item.id
        })
        this.$bus.$emit('showGiftDialog', { type: 'successPickGift', giftCode: r.result.code, failureTime: r.result.failure_time })
        this.$emit('refreshGiftList')
      } catch (error) {
        this.$bus.$emit('showGiftDialog', { type: 'failPickGift' })
      } finally {
        this.pickGiftFlag = false
        this.CHANGE_SHOW_LOADING(false)
      }
    },
    // 点击礼包查看按钮
    viewGiftCode(item) {
      if (!this.isBindAccount) {
        this.CHANGE_BIND_GAME(true)
        return
      }
      // this.$bus.$emit('showNormalDialog', 'receivedGift')
    },
    // 
  },
}
</script>

<style lang="scss" module>
@import '~@/styles/mixins.scss';
@import '~@/styles/_variable.scss';
.swiper {
  margin: 8px 0px 8px 8px;
  height: 180px;
  background-image: linear-gradient(to bottom, #fff 60%, #f9f9f9 60%);
  background-size: 100% 85px;
  background-color: #fff;
}
.swiper-item {
  display: flex;
  align-items: center;
  height: 45px !important;
  img {
    width: 45px;
  }
  div {
    margin: 0px 8px;
    width: 218px;
    height: 21px;
    display: flex;
    p:first-child {
      @include ellipsis(1);
      width: 70px;
      line-height: 21px;
      font-size: 11px;
    }
    p:last-child {
      @include ellipsis(1);
      margin-left: 8px;
      line-height: 21px;
      font-size: 10px;
      color: #9f9f9f;
    }
  }
  button {
    @include clearBtnDefaultStyle;
    padding: 0;
    width: $buttonWidth;
    height: $buttonHeight;
    color: #fff;
    font-size: 10px;
    background-color: $buttonColor;
    border-radius: 15px;
  }
}
</style>
